"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.readJson = readJson;
var _readFile = require("./readFile");
async function readJson(path, schema, options) {
  return (0, _readFile.readFile)(path, schema, options);
}
